import PropTypes from 'prop-types';

export default PropTypes.shape({
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  totalCount: PropTypes.number,
  limit: PropTypes.number
});
